import {
  useRiskProfileBaseParams,
  type UseRiskProfileBaseParamsOptions,
} from './useRiskProfileBaseParams'
import type { PropertiesQueryParams } from '../types/riskProfileProperties.types'

type UseEconomicRiskQueryParamsOptions = Omit<UseRiskProfileBaseParamsOptions, 'metric'> & {
  entityView: 'employers' | 'employees'
}

export const useEconomicRiskQueryParams = ({
  entityView,
  ...baseOptions
}: UseEconomicRiskQueryParamsOptions): PropertiesQueryParams | null =>
  useRiskProfileBaseParams({ ...baseOptions, metric: entityView })
